export default {
  reservationStep: 1,
  reservationSelectedSpots: [],
  reservationServiceId: null,
  reservationTutorId: null,
  reservationLocation: null,
  reservationParametersConfirmed: false,
}
